import React from 'react';
import { Link } from 'react-router-dom';

const NotFound = function () {
  return (
    <div className="notFound">
      <h1>404: Page Not Found</h1>
      <Link to="/">Zurück zur Startseite.</Link>
    </div>
  );
};

export default NotFound;



// WEBPACK FOOTER //
// ./src/pages/NotFound/index.js